var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group",
    [
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Кол-во заказов:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.orders.length))])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Наличные:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.cashStats()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Безналичные:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.cardInPlaceStats()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Оплата онлайн:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.cardOnlineStats()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Аванс:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.sberbankStats()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Платежная ссылка:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.paymentLinkStats()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Итого:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.allOrdersSum()) + " руб")])
        ])
      ]),
      _vm._v(" "),
      _c("b-list-group-item"),
      _vm._v(" "),
      _c("b-list-group-item", { staticClass: "salary-color" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle.HistoryOrders",
                modifiers: { HistoryOrders: true }
              }
            ],
            staticClass: "d-flex justify-content-between"
          },
          [
            _c("span", [_vm._v("↓ Зарплата за смену: ")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.deliveryPriceStats()) + " руб ↓")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { id: "HistoryOrders" } },
        [
          _c(
            "b-list-group",
            _vm._l(_vm.orders, function(order) {
              return _c("b-list-group-item", { key: order.id }, [
                _c("div", { class: _vm.orderClass(order) }, [
                  _c("span", [_vm._v("Заказ №" + _vm._s(order.idDay) + ":")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.sumPriceStats(order)) +
                        " руб. | " +
                        _vm._s(_vm.getOrderSalary(order)) +
                        " руб. "
                    )
                  ])
                ])
              ])
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-list-group-item", [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v("Итого к сдаче: ")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.oddMoney()) + " руб")])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f850911", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f850911","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourierStatDisplay.vue
// module id = null
// module chunks = 